import { Avatar, Grid, Typography, useTheme } from '@mui/material';
import React from 'react';
import { ProcureUser } from 'vendor-marketplace-shared-library';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { formatPhoneNumber } from '../../utilities/formatters';

export function UserDetailsModule(props: { user: ProcureUser }) {
  const { user } = props;
  const theme = useTheme();

  return (
    <Grid container direction={'column'} sx={styles.mainContainer}>
      <Grid item>
        <Grid container direction={'row'} columnGap={1}>
          <Grid item>
            <Avatar src={user.profilePictureAttachment?.url || ''} alt={user.fullName || ''} />
          </Grid>
          <Grid item>
            <Grid item>
              <Typography>{user.fullName}</Typography>
            </Grid>
            <Grid item>
              <Typography sx={{ color: theme.palette.secondary.main }} variant={'caption'}>
                {user.userRole!.name}
              </Typography>
            </Grid>
            {user.phoneContactMethod && (
              <Grid item container spacing={1} sx={styles.noWrap}>
                <Grid item>
                  <PhoneIcon />
                </Grid>
                <Grid item>
                  <Typography>{formatPhoneNumber(user.phoneContactMethod.value)}</Typography>
                </Grid>
              </Grid>
            )}
            {user.emailContactMethod && (
              <Grid item container spacing={1} sx={styles.noWrap}>
                <Grid item>
                  <EmailIcon />
                </Grid>
                <Grid item>
                  <Typography>{user.emailContactMethod.value}</Typography>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    backgroundColor: 'white',
    borderRadius: 1,
    padding: 2,
    border: '1px solid black',
  },
  noWrap: {
    flexWrap: 'nowrap',
  },
};
